var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcComplaintServiceBody2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 169,
    viewBox: "0 0 191 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8154 22.7594C58.8154 16.987 63.4949 12.3076 69.2672 12.3076L145.064 12.3076L145.064 124.09C145.064 129.862 140.385 134.541 134.613 134.541L58.8154 134.541L58.8154 22.7594Z",
    fill: "#FFCF85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.923 12.3076L146.035 12.3076C151.808 12.3076 156.487 16.987 156.487 22.7594L156.487 53.8337C156.487 59.6061 151.808 64.2855 146.035 64.2855H139.923L139.923 12.3076Z",
    fill: "#FFCF85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.665,
    y: 32.2988,
    width: 56.5474,
    height: 15.422,
    fill: "#FFF2DE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_730)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.415 102.727L119.415 64.2504L125.308 64.2504C125.604 63.0994 126.419 62.1568 127.49 61.6872C127.595 61.5692 127.719 61.4619 127.861 61.3689L152.192 45.4278C153.969 44.2632 156.491 44.6606 157.824 46.3153L158.083 46.6361C160.416 49.5318 159.785 53.5314 156.675 55.5694L147.829 61.3647L154.696 61.3647C154.71 61.3645 154.724 61.3644 154.738 61.3644L163.9 61.3644C165.494 61.3644 166.786 62.6563 166.786 64.2501L166.786 69.0596C166.786 70.6533 165.494 71.9453 163.9 71.9453L156.12 71.9453L156.12 71.9454L161.767 71.9454C163.36 71.9454 164.652 73.2374 164.652 74.8311L164.652 78.6787C164.652 80.2725 163.36 81.5645 161.767 81.5645L159.659 81.5645C161.242 81.5769 162.521 82.8641 162.521 84.4501L162.521 89.2596C162.521 90.8533 161.229 92.1453 159.636 92.1453L156.12 92.1453L156.12 92.1981C157.936 92.5064 159.319 94.0874 159.319 95.9913L159.319 98.877C159.319 100.781 157.936 102.362 156.12 102.67L156.12 102.727L126.148 102.727L125.187 102.727L119.415 102.727Z",
    fill: "#FFDCD5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.10059,
    y: 108.498,
    width: 50.9809,
    height: 106.771,
    transform: "rotate(-90 1.10059 108.498)",
    fill: "#374969"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_730)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.871,
    y: 105.612,
    width: 45.2095,
    height: 11.5429,
    transform: "rotate(-90 107.871 105.612)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2031_730)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98.7,
    cy: 102.595,
    r: 3.2,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2031_730)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88.3006,
    cy: 102.595,
    r: 3.2,
    fill: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_730",
    x: 116.215,
    y: 44.7598,
    width: 53.7711,
    height: 64.3668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_730",
    x: -2.09941,
    y: 57.5176,
    width: 113.171,
    height: 57.3805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_730",
    x: 104.671,
    y: 60.4023,
    width: 17.943,
    height: 51.61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2031_730",
    x: 92.3,
    y: 99.3945,
    width: 12.7999,
    height: 12.8004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2031_730",
    x: 81.9006,
    y: 99.3945,
    width: 12.7999,
    height: 12.8004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.6,
    height: 168,
    fill: "white",
    transform: "translate(0.700195 0.599609)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplaintServiceBody2Mobile);
export default __webpack_public_path__ + "static/media/IcComplaintServiceBody2Mobile.782b85b452337c00e8062e7a2ba312f8.svg";
export { ForwardRef as ReactComponent };